const SWIPER_CLASS_NAMES = {
  bulletClass: 'c-swiper-pagination__bullet',
  bulletActiveClass: 'c-swiper-pagination__bullet--active',
};

export default SWIPER_CLASS_NAMES;
